import {inDev} from '@/utils/env.js'

// let baseUri = "https://cdn.aefree.com/rawdata/online";
export let baseUri = undefined
export let auditBaseUri = undefined
// let prefix = '/rawdata/online'
export let prefix = '/fc_sourse/prd_books'
export let auditPrefix = '/fc_sourse/publish'
export let bookVersion = '_v1'
if(inDev()) {
  // baseUri = `http://localhost:8080/books`
  baseUri = `https://bookcdn.aefree.com${prefix}`
  auditBaseUri = `https://bookcdn.aefree.com${auditPrefix}`
  bookVersion = ''
}else{
  baseUri = `https://bookcdn.aefree.com${prefix}`
  auditBaseUri = `https://bookcdn.aefree.com${auditPrefix}`
}
